export default __webpack_public_path__ + "static/media/5333.f110ac34.png";